// Helper function to track events with common parameters
const trackEvent = (eventName, examType, additionalData = {}) => {
    if (examType === 'MOCK-JEE') {
      const commonData = {
        "utm parameters": localStorage.getItem("utmParams"),
        "page url": window.location.href,
        "roll number": additionalData.roll_number,
        "dob": additionalData.student_dob,
        "mobile": additionalData.mobile_number
      };
  
      // Merge common data with event-specific data
      const data = { ...commonData, ...additionalData };
      window.webengage.track(examType + eventName, data);
    }
  };
  
  export const dashboard_web = (event_name, event_data, examType) => {
    const additionalData = {
      "roll number": event_data.roll_number,
      "dob": event_data.student_dob,
      "mobile": event_data.mobile_number,
      "student_name": event_data.student_firstname,
      "email": event_data.email
    };
    trackEvent(event_name, examType, additionalData);
  };
  
  export const test_begin = (event_name, event_data, profileData, examType) => {
    const additionalData = {
      "roll number": event_data.user_id,
      "dob": event_data.dob,
      "mobile": profileData.mobile_number,
      "test_name": profileData.test_paper_name,
      "Exam_start_date": profileData.exam_date_jee,
      "paper_number": profileData.test_paper,
      "click_time": new Date().toLocaleTimeString(),
      "Test_short_code": event_data.exam_short_code
    };
    trackEvent(event_name, examType, additionalData);
  };
  
  export const result_begin = (event_name, event_data, profileData, examType) => {
    const additionalData = {
      "roll number": event_data.user_id,
      "dob": event_data.dob,
      "mobile": profileData.mobile_number,
      "test_name": profileData.test_paper_name,
      "Exam_start_date": profileData.exam_date_jee,
      "paper_number": profileData.test_paper,
      "Test_short_code": event_data.exam_short_code
    };
    trackEvent(event_name, examType, additionalData);
  };
  
  export const view_drop_click = (event_name, data_click, profileData, examType) => {
    const additionalData = {
      "roll number": profileData.roll_number,
      "dob": profileData.student_dob,
      "mobile": profileData.mobile_number,
      "test_name": data_click.test_name,
      "Exam_start_date": data_click.exam_date_jee
    };
    trackEvent(event_name, examType, additionalData);
  };
  
  export const click_on_phone = (event_name, center, profileData, examType) => {
    const additionalData = {
      "roll number": profileData.roll_number,
      "dob": profileData.student_dob,
      "mobile": profileData.mobile_number,
      "branch_name": center
    };
    trackEvent(event_name, examType, additionalData);
  };
  
  export const video_show = (event_name, profileData, examType) => {
    const additionalData = {
      "roll number": profileData.roll_number,
      "dob": profileData.student_dob,
      "mobile": profileData.mobile_number,
      "video_url": "https://d28cs5wqm3s0uy.cloudfront.net/Homepage_Banners/demo_section.mp4"
    };
    trackEvent(event_name, examType, additionalData);
  };
  
  export const calender_shift = (event_name, profileData, examType) => {
    const nextMonthDate = new Date(profileData.month_changed);
    const nextMonthIndex = (nextMonthDate.getMonth() + 1) % 12;
    nextMonthDate.setMonth(nextMonthIndex);
    const nextMonth = nextMonthDate.toLocaleString('en-US', { month: 'short' });
  
    const additionalData = {
      "roll number": profileData.roll_number,
      "dob": profileData.student_dob,
      "mobile": profileData.mobile_number,
      "Changed_month": nextMonth
    };
    trackEvent(event_name, examType, additionalData);
  };
  
  export const change_date = (event_name, profileData, examType) => {
    const dateIndex = profileData.month_changed.getDate();
    const calendar_month = profileData.month_changed.toLocaleString('en-US', { month: 'short' });
  
    const additionalData = {
      "roll number": profileData.roll_number,
      "dob": profileData.student_dob,
      "mobile": profileData.mobile_number,
      "exam_date_clicked": dateIndex,
      "selected_month": calendar_month
    };
    trackEvent(event_name, examType, additionalData);
  };
  
  export const dashboard_load_fail = (event_name, profileData, examType) => {
    const additionalData = {
      "roll number": profileData.roll_number,
      "dob": profileData.student_dob,
      "mobile": profileData.mobile_number,
      "error message": "Api call fails"
    };
    trackEvent(event_name, examType, additionalData);
  };
  
  export const begin_test_fail = (event_name, profileData, examType) => {
    const additionalData = {
      "roll number": profileData.roll_number,
      "dob": profileData.student_dob,
      "mobile": profileData.mobile_number,
      "test_name": profileData.test_paper_name
    };
    trackEvent(event_name, examType, additionalData);
  };
  
  export const result_show_fail = (event_name, profileData, examType) => {
    const additionalData = {
      "roll number": profileData.roll_number,
      "dob": profileData.student_dob,
      "mobile": profileData.mobile_number,
      "test_name": profileData.test_paper_name
    };
    trackEvent(event_name, examType, additionalData);
  };
  





